import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { Period } from '../types';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface DateNavigationProps {
  date: Date;
  period: Period;
  onPrev: () => void;
  onNext: () => void;
  onDateClick: () => void;
  onDateChange: (date: Date) => void;
}
export function DateNavigation({
  date,
  period,
  onPrev,
  onNext,
  onDateClick,
  onDateChange
}: DateNavigationProps) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(date.toISOString().split('T')[0]);
  const formatDate = (d: Date, p: Period) => {
    const options: Intl.DateTimeFormatOptions = {};
    if (p === 'day') {
      options.weekday = 'short';
      options.month = 'short';
      options.day = 'numeric';
    } else if (p === 'month') {
      options.month = 'long';
      options.year = 'numeric';
    } else {
      options.year = 'numeric';
    }
    return new Intl.DateTimeFormat('en-US', options).format(d);
  };
  const handleDateSelect = () => {
    onDateChange(new Date(selectedDate));
    setShowDatePicker(false);
  };
  return <>
      <div className="flex items-center justify-between w-full max-w-xs mx-auto mt-4 px-2" data-id="element-40">
        <button onClick={onPrev} className="p-2 rounded-full hover:bg-stone-800 text-stone-400 hover:text-amber-500 transition-colors" data-id="element-41">
          <ChevronLeft size={24} data-id="element-42" />
        </button>

        <button onClick={() => setShowDatePicker(true)} className="flex items-center gap-2 px-4 py-2 rounded-xl hover:bg-stone-800 transition-colors group" data-id="element-43">
          <Calendar size={18} className="text-stone-500 group-hover:text-amber-500 transition-colors" data-id="element-44" />
          <span className="text-lg font-semibold text-stone-200 group-hover:text-white transition-colors" data-id="element-45">
            {formatDate(date, period)}
          </span>
        </button>

        <button onClick={onNext} className="p-2 rounded-full hover:bg-stone-800 text-stone-400 hover:text-amber-500 transition-colors" data-id="element-46">
          <ChevronRight size={24} data-id="element-47" />
        </button>
      </div>

      {/* Date Picker Modal */}
      <AnimatePresence data-id="element-48">
        {showDatePicker && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowDatePicker(false)} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-49" />
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-stone-900 rounded-3xl z-50 p-6 w-[90%] max-w-sm border border-stone-800 shadow-2xl" data-id="element-50">
              <div className="flex justify-between items-center mb-6" data-id="element-51">
                <h2 className="text-xl font-bold text-stone-50" data-id="element-52">Select Date</h2>
                <button onClick={() => setShowDatePicker(false)} className="p-2 bg-stone-800 rounded-full text-stone-400 hover:text-stone-200" data-id="element-53">
                  <X size={20} data-id="element-54" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-55">
                <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} className="w-full bg-stone-800 text-stone-50 py-4 px-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-amber-500/50 text-lg" data-id="element-56" />

                <div className="flex gap-3" data-id="element-57">
                  <button onClick={() => setShowDatePicker(false)} className="flex-1 py-3 bg-stone-800 text-stone-300 font-medium rounded-xl hover:bg-stone-700 transition-colors" data-id="element-58">
                    Cancel
                  </button>
                  <button onClick={handleDateSelect} className="flex-1 py-3 bg-amber-500 text-stone-900 font-bold rounded-xl hover:bg-amber-400 transition-colors" data-id="element-59">
                    Go to Date
                  </button>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}